// export const REQUEST_NOTIFICATION = 'REQUEST_NOTIFICATION';
// export const SUCCESS_NOTIFICATION = 'SUCCESS_NOTIFICATION';
// export const ERROR_NOTIFICATION = 'ERROR_NOTIFICATION';
export const ADD_ID_PROJETO = 'ADD_ID_PROJETO';
export const REMOVE_ID_PROJETO = 'REMOVE_ID_PROJETO';
export const SEND_COLABS_FILTEREDS = 'SEND_COLABSFILTEREDS';
export const SEND_COLABS = 'SEND_COLABS';